import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ErrorBag } from '@/core/common';
import { UserUpdate } from '@/modules/user/User';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';

interface CustomerFormUserProps {
	user: UserUpdate;
	errors: ErrorBag;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormUser',
  props: {
    user: {},
    errors: {}
  },
  emits: [
	'update:user',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const props = __props;
const emit = __emit;

const data = ref<Partial<UserUpdate>>({});

onMounted(() => data.value = Object.assign({}, props.user));

watch(() => data.value, (value) => {
	emit('update:user', value);
}, {
	deep: true,
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[3] || (_cache[3] = [
      _createTextVNode("Kundadministratör", -1)
    ]))])), [
      [_directive_translate]
    ]),
    _createVNode(AppFormGroup, {
      id: "user_name",
      errors: __props.errors.name,
      label: _unref($gettext)('Namn')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          id: "user_name",
          modelValue: data.value.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.name) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "user_email",
      errors: __props.errors.email,
      label: _unref($gettext)('E-post')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          type: "email",
          id: "user_email",
          modelValue: data.value.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.email) = $event)),
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    _createVNode(AppFormGroup, {
      id: "user_password",
      errors: __props.errors.password,
      label: _unref($gettext)('Lösenord')
    }, {
      default: _withCtx(() => [
        _createVNode(AppInput, {
          type: "password",
          id: "user_password",
          modelValue: data.value.password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.password) = $event)),
          placeholder: "********",
          required: !data.value.id
        }, null, 8, ["modelValue", "required"])
      ]),
      _: 1
    }, 8, ["errors", "label"])
  ]))
}
}

})